<template>
    <div class="container details-container subject-container">
        <div class="subject-content">
            <div class="guide-wrapper" :style="{backgroundColor:color}">
                <commonTop :banner="banner" v-if="hide!==true" :applyUrl="applyUrl" :test="test"> </commonTop>
                <template v-if="activity ==='jy85'">
                    <jy85></jy85>
                </template>
                <template v-else-if="activity ==='cxfq'">
                    <cxfq></cxfq>
                </template>
                <template v-else-if="activity ==='thyc'">
                    <thyc></thyc>
                </template>
                <template v-else-if="activity ==='xsty'">
                    <xsty></xsty>
                </template>
                
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import jy85 from "./jy85";
import cxfq from "./cxfq";
import thyc from "./thyc";
import xsty from "./xsty";

import commonTop from "@/components/activityTop";
export default {
    data() {
        return {
            banner: "",
            applyUrl: "",
            color: "",
            hide: false,
            describe: "",
            test:""
        };
    },
    props: {
        activity: String,
        subject: String,
    },
    mounted() {
        this.initData();
    },
    computed: {
        ...mapState(["subjectActivity"]),
    },
    methods: {
        initData() {
            this.banner = this.subjectActivity[this.subject][
                this.activity
            ].image;
            this.color = this.subjectActivity[this.subject][
                this.activity
            ].color;
            this.applyUrl = this.subjectActivity[this.subject][
                this.activity
            ].applyUrl;
            this.hide = this.subjectActivity[this.subject][this.activity].hide;
            this.test = this.subjectActivity[this.subject][this.activity].test;
        },
    },
    components: {
        jy85,
        commonTop,
        cxfq,
        thyc,
        xsty,
        
    },
};
</script>

<style lang="scss" scoped>
</style>